import { CurrencyInput } from './Currency'

export interface Web3Input {
  Currency: typeof CurrencyInput
}

export const Web3Input: Web3Input = {
  Currency: CurrencyInput,
}
